"use strict";

require("core-js/modules/es.array.sort.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountrySelector = void 0;

var react_1 = __importDefault(require("react"));

var countries_list_1 = require("countries-list");

var Select_1 = require("../Select");

var Label_1 = require("../Label");

var CountrySelector_styles_1 = require("./CountrySelector.styles");

var CountrySelector = function CountrySelector(_a) {
  var id = _a.id,
      label = _a.label,
      error = _a.error,
      onChange = _a.onChange,
      hide = _a.hide,
      errorShouldReplaceLabel = _a.errorShouldReplaceLabel,
      props = __rest(_a, ["id", "label", "error", "onChange", "hide", "errorShouldReplaceLabel"]);

  var options = [];
  var sortedCountries = Object.entries(countries_list_1.countries).map(function (country) {
    return {
      code: country[0],
      name: country[1]['name']
    };
  });
  sortedCountries.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  }).map(function (country) {
    return options.push(react_1.default.createElement("option", {
      key: country.code,
      value: country.code
    }, country.name));
  });
  return react_1.default.createElement(CountrySelector_styles_1.CountrySelectorContainer, {
    hide: hide
  }, react_1.default.createElement(Label_1.Label, {
    "data-testid": id + "_label",
    htmlFor: id,
    label: label,
    error: error,
    style: {
      opacity: props.disabled ? 0.3 : 1
    },
    errorShouldReplaceLabel: errorShouldReplaceLabel
  }), react_1.default.createElement(Select_1.Select, __assign({
    id: id,
    "data-testid": id,
    error: !!error,
    onChange: onChange
  }, props), options));
};

exports.CountrySelector = CountrySelector;